import React from 'react';
import './JobDetailsModal.css';

const JobDetailsModal = ({ job, onClose, onContinue }) => {
  if (!job) return null;

  return (
    <div className="job-modal-overlay" onClick={onClose}>
      <div className="job-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="job-modal-close" onClick={onClose}>×</button>
        
        <div className="job-modal-header">
          <h2>{job.title}</h2>
          <p className="job-modal-company">AG&WESTERN Rail Inc.</p>
        </div>

        <div className="job-modal-body">
          <section className="job-section">
            <h3>Position Overview</h3>
            <p>{job.overview}</p>
          </section>

          <section className="job-section">
            <h3>Key Responsibilities</h3>
            <ul>
              {job.responsibilities.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="job-section">
            <h3>Required Qualifications</h3>
            <ul>
              {job.qualifications.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </section>

          {job.preferred && job.preferred.length > 0 && (
            <section className="job-section">
              <h3>Preferred Qualifications</h3>
              <ul>
                {job.preferred.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </section>
          )}
        </div>

        <div className="job-modal-footer">
          <button className="job-modal-button-secondary" onClick={onClose}>
            Close
          </button>
          <button className="job-modal-button-primary" onClick={onContinue}>
            Continue to Application →
          </button>
        </div>
      </div>
    </div>
  );
};

export default JobDetailsModal;
